module.exports = __webpack_public_path__ + "static/img/27.754e85ef.jpg";